import { Reducer } from 'redux'
import { DetailPageActions, DetailPageActionTypes } from '../actions'
import { PType } from '../integrations/aui'
import { store } from '../store'

declare let window: Window & { P: PType }

if (!global.__SERVER__ && window.P) {
  window.P.when('deeplinking').execute(() => {
    store.dispatch({ type: DetailPageActionTypes.DeeplinkingReady })
  })
}

export type Deeplinking = {
  ready: boolean
}

const initialState = { ready: false } as Deeplinking

export const reducer: Reducer<Deeplinking, DetailPageActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case DetailPageActionTypes.DeeplinkingReady:
      return { ...state, ready: true }
    default:
      return state
  }
}
